import React, {Component} from 'react'

class ServiceLeftColumn extends Component {
  render() {
    return <div className="tile is-12 is-child box">
      <p>Состав комплекта:</p>
      <ul style={{listStyle: 'none'}}>
        <li>Выберите необходимые услуги, установив «галочку»:</li>
        <li style={{fontSize: '12pt'}}>
          <label className="checkbox">
            <input type="checkbox" name="kktactivation" checked={this.props.kktactivation} onChange={this.props.changeService} />
            Код активации ККТ на услугу ОФД
          </label>
        </li>
      </ul>
    </div>
  }
}

export default ServiceLeftColumn


// WEBPACK FOOTER //
// ./src/components/ofdCalc/leftColumn/ServiceLeftColumn.js